import React, { useEffect, useState } from 'react';
import ProductSearchBar from '../products/ProductSearchBar';
import CartModal from '../cart/cartModal';

const Index = () => {
    const [exist, setExist] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setExist(true);
    }, 1000)
  }, [])
    return (
        <div>
            {exist && <>
               <CartModal />
                <ProductSearchBar />
              </>}
        </div>
    );
}

export default Index;
